import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import ProductProp from '../propTypes/productProp';
import ProductSubscriptionDebitDate from './ProductSubscriptionDebitDate';
import cx from 'classnames';

function ShopProductSubscription({
  t,
  product,
  handleSubscriptionCheckbox,
  subscriptionFrequency,
}) {
  const [isCollapsed, setIsCollapsed] = React.useState(false);
  const [subscriptionFrequencies, setSubscriptionFrequencies] = React.useState(
    product?.availableSubscriptionFrequency,
  );

  useEffect(() => {
    setSubscriptionFrequencies(
      product?.availableSubscriptionFrequency.filter(
        s => s !== subscriptionFrequency,
      ),
    );
  }, [subscriptionFrequency]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleSelectFrequency = frequency => {
    handleSubscriptionCheckbox(frequency);
    toggleCollapse();
  };

  return (
    <div className="subscription-display-container">
      <div className="main-title">
        {t('shop.product.subscription.frequency')}
      </div>
      <div
        data-testid="subscription-frequency"
        className="subscription-frequency row"
      >
        <div className="col-12">
          <div className="current-frequency-label selected-frequency">
            <div className="current-frequency-label-text">
              <span className="frequency">
                {t(
                  `shop.product.subscription.frequency.${subscriptionFrequency}`,
                )}
              </span>
              <span className="timing">
                <ProductSubscriptionDebitDate
                  product={product}
                  frequency={subscriptionFrequency}
                />
              </span>
            </div>
            {subscriptionFrequencies.length > 0 && (
              <div className="current-frequency-label-button">
                <button
                  type="button"
                  className={cx('button', 'button-frequency-collapse', {
                    collapsed: isCollapsed,
                  })}
                  onClick={toggleCollapse}
                >
                  {isCollapsed ? (
                    <i className="fa fa-solid fa-chevron-up"></i>
                  ) : (
                    <i className="fa fa-solid fa-chevron-down"></i>
                  )}
                </button>
              </div>
            )}
          </div>
          <div
            className={cx('subscription-frequency-list', {
              collapsed: isCollapsed,
            })}
          >
            {subscriptionFrequencies?.map((frequency, i) => (
              <div
                key={i}
                className="current-frequency-label frequency-to-select"
                onClick={() => handleSelectFrequency(frequency)}
              >
                <div className="current-frequency-label-text">
                  <span className="frequency">
                    {t(`shop.product.subscription.frequency.${frequency}`)}
                  </span>
                  <span className="timing">
                    <ProductSubscriptionDebitDate
                      product={product}
                      frequency={frequency}
                    />
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

ShopProductSubscription.propTypes = {
  t: PropTypes.func.isRequired,
  product: PropTypes.shape(ProductProp.propType).isRequired,
  handleSubscriptionCheckbox: PropTypes.func.isRequired,
  subscriptionFrequency: PropTypes.string.isRequired,
};

export default translate(ShopProductSubscription);
